import {
  GoogleLocationReview,
  PaginatedResponse,
  ReviewAggregatedFilterData,
  ReviewGetType,
  ReviewInterface,
  ReviewPlatform,
  ReviewSyncJobData
} from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// LINK - apps/server/src/API/Reviews/Reviews.Controller.ts
export class ReviewsAPI {
  static async getReviews(orgId: number, type?: ReviewGetType) {
    return APIService.Server.get<ReviewInterface[]>(`/reviews/org/${orgId}`, { type });
  }

  static async getReviewsPaginated(
    orgId: number,
    type: ReviewGetType,
    page: number,
    limit: number,
    hasReply?: boolean,
    rating?: number,
    platform?: ReviewPlatform,
    locationId?: number[],
    deletedOnGoogle?: boolean
  ) {
    const params: any = {
      type,
      page,
      limit
    };

    if (hasReply !== undefined) {
      params.hasReply = hasReply;
    }
    if (rating !== undefined) {
      params.rating = rating;
    }
    if (platform !== undefined) {
      params.platform = platform;
    }
    if (locationId !== undefined) {
      params.locationId = locationId;
    }
    if (deletedOnGoogle !== undefined) {
      params.deletedOnGoogle = deletedOnGoogle;
    }

    const queryParams = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (Array.isArray(value)) {
        value.forEach((item: any) => {
          queryParams.append(key, String(item));
        });
      } else {
        queryParams.append(key, String(value));
      }
    });

    const queryString = queryParams.toString();
    const url = `/reviews/org/${orgId}/paginated${queryString ? `?${queryString}` : ""}`;

    return APIService.Server.get<PaginatedResponse<ReviewInterface>>(url, undefined);
  }

  static async getAggregatedReviewData(orgId: number, type?: ReviewGetType) {
    return APIService.Server.get<ReviewAggregatedFilterData>(`/reviews/org/${orgId}/aggregated-data`, { type });
  }
  static async getReviewByPlatformReviewId(orgId: number, platformReviewId: string) {
    return APIService.Server.get<ReviewInterface>(`/reviews/org/${orgId}/platform-review-id/${platformReviewId}`);
  }
  static async getMostRecentReview(orgId: number, locationId: number) {
    return APIService.Server.get<ReviewInterface>(`/reviews/org/${orgId}/location/${locationId}/most-recent`);
  }

  static async syncReview(orgId: number, job: ReviewSyncJobData, googleReview: GoogleLocationReview) {
    return APIService.Server.post<ReviewInterface>(`/reviews/org/${orgId}/sync-google-review`, { googleReview, job });
  }

  static async replyToReview(
    orgId: number,
    id: number,
    body: {
      replyText: string;
      repliedByName: string;
      repliedByMemberId: number;
      replyPlatfrom: ReviewPlatform;
    }
  ) {
    return APIService.Server.post<ReviewInterface>(`/reviews/org/${orgId}/review/${id}/reply`, body);
  }

  static async deleteReviewReply(orgId: number, id: number) {
    return APIService.Server.post<ReviewInterface>(`/reviews/org/${orgId}/review/${id}/delete-reply`);
  }
  static async setArchivedOnReviews(
    orgId: number,
    body: {
      ids: number[];
      isArchived: boolean;
    }
  ) {
    return APIService.Server.post<ReviewInterface[]>(`/reviews/org/${orgId}/reviews/set-archived`, body);
  }
}
